import React, {useEffect, useState} from "react";
import "../css/main.css";
import "../css/dashboard.css";
import AddTourModal from "../components/AddTourModal";
import DashTours from "../components/DashTours";
import {useNavigate} from "react-router-dom";
import Sidebar from "./Sidebar";

const UserDashboard = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [refreshList, setRefreshList] = useState(false);
    const [selectedTour, setSelectedTour] = useState(null);
    const universityId = localStorage.getItem("universityId");
    const firstName = localStorage.getItem("firstName");
    const [numbers, setNumbers] = useState([]);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

     useEffect(() => {
        fetch(`${apiUrl}/dashboard/${universityId}/numbers`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch numbers");
                }
                return response.json();
            })
            .then((data) => setNumbers(data))
            .catch((error) => {
                console.error("Error fetching numbers:", error);
                setError("Failed to load statistics. Please try again.");
            });

    }, []);
    const handleSaveTour = () => {
        setRefreshList((prev) => !prev); // Trigger list refresh
        setSelectedTour(null); // Clear selected tour after save
    };
    const handleEditTour = (tour) => {
        setSelectedTour(tour); // Set the selected tour for editing
        setShowAddModal(true);
    };
    return (
        <div className="dashboard">
           <Sidebar/>

            <main className="main-content">
                <header className="header">
                    <h3>Welcome back, {firstName}!</h3>
                    <h4>Overview</h4>
                    <hr/>
                    <div className="overview">
                         {console.log(numbers)}
                        <div className="overview-item">
                            <h2>{numbers[0]}</h2>
                            <p>Tours</p>
                        </div>
                        <div className="overview-item">
                            <h2>{numbers[1]}</h2>
                            <p>Events</p>
                        </div>
                        <div className="overview-item">
                            <h2>{numbers[2]}</h2>
                            <p>Submissions</p>
                        </div>
                    </div>
                </header>

                <section className="quick-actions">
                    <h4>Quick Actions</h4>
                    <hr/>
                    <div className="actions">
                        <button onClick={() => {
                            setSelectedTour(null); // Clear selected tour for new tour
                            setShowAddModal(true);
                        }} className="action-button new-tour"><i className="fa fa-map" aria-hidden="true"></i> +
                            New Tour
                        </button>

                        <a href="/new-form" className="action-button new-form"><i className="fa fa-sticky-note"
                                                                                  aria-hidden="true"></i> +
                            New Form Template</a>
                    </div>
                </section>
                <DashTours
                    universityId={universityId}
                    refreshKey={refreshList}
                    onEdit={handleEditTour}
                />

            </main>
            {showAddModal && (
                <AddTourModal
                    universityId={universityId}
                    tour={selectedTour}
                    onClose={() => setShowAddModal(false)}
                    onSave={handleSaveTour}
                />
            )}
        </div>

    );
};

export default UserDashboard;